import { jsx as o } from "react/jsx-runtime";
import a from "../base-button.mjs";
const n = (r) => /* @__PURE__ */ o(
  a,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-brand-primary",
    hoverBackgroundColor: "hover:bg-brand-primary-hover",
    ...r
  }
);
export {
  n as PrimaryButton
};
